export const ACTIVE = 'ACTIVE';
export const MY_RECENT = 'MY_RECENT';
export const USER_FAVORITED = 'USER_FAVORITED';
export const ARCHIVED = 'ARCHIVED';
export const ALL = 'ALL';
export const COMPLETE = 'COMPLETE';
export const INCOMPLETE = 'INCOMPLETE';
